module.exports = __webpack_public_path__ + "prod/1.42.2/img/fenxiao-four.8865508e.png";